/**
 * Turns API error JSON (`response.text()` from fetch) into text suitable for the UI.
 * Prefers localized strings for known `error` codes, then `message`, then raw body.
 */
export function formatBusinessPartnerApiError(
    raw: string | null | undefined,
    localizedByErrorCode: Record<string, string | undefined>
): string {
    if (!raw) return '';
    try {
        const parsed = JSON.parse(raw) as { error?: string; message?: string };
        const code = parsed?.error;
        if (typeof code === 'string') {
            const localized = localizedByErrorCode[code];
            if (localized?.trim()) return localized.trim();
        }
        if (typeof parsed?.message === 'string' && parsed.message.trim()) {
            return parsed.message.trim();
        }
    } catch {
        /* not JSON */
    }
    return raw;
}
